var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"h-100",attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100"},[_c('b-col',{attrs:{"cols":"5"}},[_c('results')],1),_c('b-col',{attrs:{"cols":"7"}},[_c('Map',{attrs:{"layers":_vm.layers}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }